module.exports = __webpack_public_path__ + "img/bg-login.ff004aa3.svg";